import PropTypes from 'prop-types'
import React from 'react'
import { useParams } from 'react-router'
import { Button, Margin, Panel } from 'shared/components'

const AddAthleteButtonComponent = ({ loadTeamById, onTrigger }) => {
  const { teamId } = useParams()
  const addAthleteButtonHandler = () => {
    loadTeamById(teamId)
    onTrigger()
  }
  return (
    <Margin top={-4}>
      <Panel>
        <Button
          primary
          medium
          title="Add athlete to team"
          onClick={addAthleteButtonHandler}
        >
          Add athlete to team
        </Button>
      </Panel>
    </Margin>
  )
}

AddAthleteButtonComponent.propTypes = {
  loadTeamById: PropTypes.func.isRequired,
  onTrigger: PropTypes.func.isRequired,
}

export default AddAthleteButtonComponent
